// Función que devuelve el nombre del tipo de tag basado en el número proporcionado
export const Get_type_tag_name = (type_tag: number | null): string => 
{
  if (type_tag === null)
  {
    return "<desconocido>"
  }
  else
  {
    switch (type_tag) 
    {
      case 0:
        return "BEFORE";
      case 1:
        return "AFTER";
      case 2:
        return "NO TIME";
      default:
        return type_tag.toString();
    }
  }
};

//-------------------------------------------------------------

// Función para obtener las opciones disponibles para el selector
export const Get_type_tag_options = () => [
  { value: 0, label: Get_type_tag_name(0) },
  { value: 1, label: Get_type_tag_name(1) },
  { value: 2, label: Get_type_tag_name(2) },
];

//-------------------------------------------------------------

// Función que devuelve el nombre del tipo de codigo basado en el número proporcionado
export const Get_type_code_name = (type: number | null): string => 
{
  if (type === null)
  {
    return "<desconocido>";
  }
  else
  {
    switch (type) 
    {
      case 0:
        return "CTSTREET";
      case 1:
        return "ONLINE";
      case 2:
        return "WORKER";
      case 3:
        return "FREE";        
      default:
        return type.toString();
    }
  }
};

//-------------------------------------------------------------

// Función para obtener las opciones disponibles para el selector
export const Get_type_code_options = () => [
  { value: 0, label: Get_type_code_name(0) },
  { value: 1, label: Get_type_code_name(1) },
  { value: 2, label: Get_type_code_name(2) },
  { value: 3, label: Get_type_code_name(3) },
];

//-------------------------------------------------------------

export function Debounce(func: Function, wait: number) 
{
  let timeout: NodeJS.Timeout;
  return function(...args: any[]) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
  };
}

//-------------------------------------------------------------

// Función que devuelve el nombre del tipo de uso basado en el número proporcionado
export const Get_use_type_name = (use_type: number | null): string => 
  {
    if (use_type === null)
    {
      return "<desconocido>";
    }
    else
    {
      switch (use_type) 
      {
        case 0:
          return "ACEPTADO";
        case 1:
          return "CHECK OK";
        case 2:
          return "EXCESO USOS";
        case 3:
          return "DESCONOCIDO";
        case 4:
          return "CHECK FAIL";          
        default:
          return use_type.toString();
      }
    }
  };

  //-----------------------------------------------------------

  export const Truncar_dispositivo = (device: string) => 
  {
    // Verifica si la cadena es más larga que 25 caracteres
    if (device.length > 28) {
      // Devuelve la cadena sin los últimos 10 caracteres
      return device.slice(0, -28);
    }
    // Si la cadena tiene 10 caracteres o menos, devuelve una cadena vacía
    return device;
  };

  //-----------------------------------------------------------

  export const DateTime_to_string = (date: Date): string => 
  {
    const formattedDate = date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    
    const formattedTime = date.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });

    return `${formattedDate} ${formattedTime}`;
  };

  //-----------------------------------------------------------

  export const Get_today_range = () => 
  {
    const today = new Date();
    const start_dt = today.toISOString().split('T')[0] + 'T00:00';
    const end_dt = today.toISOString().split('T')[0] + 'T23:59';
    return { start_dt, end_dt };
  };

  //-----------------------------------------------------------

  export const Get_yesterday_range = () => 
  {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const start_dt = yesterday.toISOString().split('T')[0] + 'T00:00';
      const end_dt = yesterday.toISOString().split('T')[0] + 'T23:59';
      return { start_dt, end_dt };
  };

  //-----------------------------------------------------------

  export const Get_this_week_range = () => 
  {
      const startOfWeek = new Date();
      const dayOfWeek = startOfWeek.getDay();
      const daysToMonday = (dayOfWeek === 0) ? 6 : (dayOfWeek - 1);
      startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const start_dt = startOfWeek.toISOString().split('T')[0] + 'T00:00';
      const end_dt = endOfWeek.toISOString().split('T')[0] + 'T23:59';
      return { start_dt, end_dt };
  };

  //-----------------------------------------------------------

    export const Get_last_week_range = () => 
    {
        const startOfWeek = new Date();
        const dayOfWeek = startOfWeek.getDay();
        const daysToMonday = (dayOfWeek === 0) ? 6 : (dayOfWeek - 1);
        startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
        const startOfLastWeek = new Date(startOfWeek);
        startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);
        const endOfLastWeek = new Date(startOfLastWeek);
        endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
        const start_dt = startOfLastWeek.toISOString().split('T')[0] + 'T00:00';
        const end_dt = endOfLastWeek.toISOString().split('T')[0] + 'T23:59';
        return { start_dt, end_dt };
    };

  //-----------------------------------------------------------

    export const Get_this_month_range = () => 
    {
        const startOfMonth = new Date();
        startOfMonth.setDate(1);
        const endOfMonth = new Date(startOfMonth);
        endOfMonth.setMonth(endOfMonth.getMonth() + 1);
        endOfMonth.setDate(0);
        const start_dt = startOfMonth.toISOString().split('T')[0] + 'T00:00';
        const end_dt = endOfMonth.toISOString().split('T')[0] + 'T23:59';
        return { start_dt, end_dt };
    };

  //-----------------------------------------------------------